var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-image"},[_c('img',{attrs:{"src":require("../static/img/bottomImg.png")}})])}]

export { render, staticRenderFns }